module.exports = __webpack_public_path__ + "img/pic_result_nodata.cd16cea8.png";